import React, { useEffect, useState, useRef } from 'react';
import { HomeWrapper } from '../components/utils/HomeWrapper';
import { PageTitle } from '../components/utils/PageTitle';
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from '../api/CommProvider';
import Card from '@mui/material/Card';
import { Paper } from "@material-ui/core";
import { Tabs, Tab } from "@material-ui/core";
import { TextField, Select, MenuItem } from '@mui/material';
import { TeamRankingTable } from "../components/teams/TeamRankingTable";
import { pTeamsRanking } from "../utils/parameters";
import { RankingTeams1, RankingTeams2, RankingTeams3 } from "../utils/icons";
import { LinearProgress } from "@material-ui/core";
import { Button} from '@mui/material';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";

import "../styles/devices/mob_UserProfile.css";
var lodash = require('lodash');


export function Leaderboard(props) {
    const {} = props;
    const { t } = useTranslation("global")

    const { comm_getLeaderboard } = useCommProvider();
    const { token_id, currentUser } = useDataProvider();
    const [ rankingTabValue, setRankingTabValue ] = useState(0);
    const [ranking_data, setRanking_data] = useState({});
    const [rankingType, setRankingType ] = useState("TOTAL_POINTS");
    const rankDataIndex = useRef();
    const chartTeamsData = useRef({});

    useEffect(() => {
        // console.log('RankingTeams RANKING SECTION');
         /* DEBUG TEMP DISABLE FECTHING FROM SERVER WHILE IT DOESN'T RESPOND */
        async function getRankingTeams() {
            setRanking_data(await comm_getLeaderboard(token_id, currentUser, 'GLOBAL'));
        }
        getRankingTeams();
    }, []);

    // useEffect(() => {

    //     console.log("🚀 ~ file: Leaderboard.js:99 ~ Leaderboard ~ ranking_data:", ranking_data)

    // }, [ranking_data]);
    
  
    function handleTabChange(e, newValue) {
    //   console.log("🚀 ~ file: RankingTeams.js:90 ~ handleTabChange ~ handleTabChange:", handleTabChange)
      switch(newValue) {
        case 0:
          setRankingType("TOTAL_POINTS");
          break;
        case 1:
          setRankingType("VIDEO_POINTS");
          break;
        case 2:
          setRankingType("LEXICO_POINTS");
          break;
        default: 
          console.error("Unexpected new value of tab index in Team Ranking"); 
          break;
      }
      setRankingTabValue(newValue);
    }


    return (
        <HomeWrapper>
            <PageTitle title={t("sDrawer.leaderboard").toUpperCase()}/>
            <div className='sig_Hub_InfoTitle sig_Teams_Title'>
                RANKING

                <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="bottom"
                    enterTouchDelay={50}
                    arrow
                    key="calculating"
                    title={
                    <div className="sig_CustomTooltip_Content">
                        <span> {t("sRanking.updateInfo")} </span>
                    </div>
                }>
                    <Button style={{padding: '0px', top: '5px', margin: '0px', minWidth: '30px', height: '30px'}}>
                        <LiveHelpIcon className="sig_Collab_UndoIcon" style={{fontSize: '15px'}} /> 
                    </Button>
                </Tooltip>
            </div>
            <Paper className="sig_TR_PaperContent">
                <Card elevation={0}>
                <div className='sig_Teams_Info_Root sig_TR_Info_Root'>
                    <div className='sig_Teams_MainContainer'>
                    <Tabs
                    className="sig_VersusMachine_Ranking_Tabs"
                    TabIndicatorProps={{ style: {'backgroundColor': '#f84848'}}}
                    value={rankingTabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="secondary"
                    variant="fullWidth"
                    centered
                    >
                        <Tab icon={<RankingTeams1 tabSelected={rankingTabValue === 0}/>} className="sig_VersusMachine_Ranking_Tab" label={t("sRanking.general")}/>
                        <Tab icon={<RankingTeams2 tabSelected={rankingTabValue === 1}/>} className="sig_VersusMachine_Ranking_Tab" label={t("sRanking.video")}/>
                        <Tab icon={<RankingTeams3 tabSelected={rankingTabValue === 2} />} className="sig_VersusMachine_Ranking_Tab" label={t("sRanking.lexicon")}/>
                    </Tabs>
                    </div>
                </div>
                </Card>

                <div className="sig_TR_RankingContainer">
                {!lodash.isEmpty(ranking_data) ? (
                    <TeamRankingTable rankingData={ranking_data} rankingType={rankingType}/>
                ) : (
                    <div className="sig_TR_Loading">
                       <LinearProgress color="primary" />
                    </div>
                )}
                </div>
            </Paper>
        </HomeWrapper>
    )
}